/**
 * Environment Configuration Utilities
 * Access environment-specific settings safely
 */

// Get current environment
export const getEnvironment = () => {
  return process.env.REACT_APP_ENV || 'development';
};

// Environment checks
export const isDevelopment = () => getEnvironment() === 'development';
export const isStaging = () => getEnvironment() === 'staging';
export const isProduction = () => getEnvironment() === 'production';

// Get API URL
export const getApiUrl = () => {
  return process.env.REACT_APP_BACKEND_URL || 'http://localhost:5000';
};

// Configuration object
export const config = {
  // Environment
  env: getEnvironment(),
  isDev: isDevelopment(),
  isStaging: isStaging(),
  isProd: isProduction(),
  
  // URLs
  apiUrl: getApiUrl(),
  
  // Stripe
  stripePublishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY || '',
  
  // Feature flags (can be environment-specific)
  features: {
    enableDebugMode: isDevelopment(),
    enableAnalytics: isProduction(),
    enableMockData: isDevelopment(),
    showEnvironmentBadge: !isProduction(),
  },
  
  // Logging
  logging: {
    level: isDevelopment() ? 'debug' : 'error',
    enableConsole: !isProduction(),
  }
};

// Environment badge component helper
export const getEnvironmentBadge = () => {
  const env = getEnvironment();
  const badges = {
    development: { label: 'DEV', color: 'bg-blue-500' },
    staging: { label: 'STAGING', color: 'bg-amber-500' },
    production: { label: '', color: '' }, // No badge in production
  };
  return badges[env] || badges.development;
};

// Safe console logging (only in dev/staging)
export const devLog = (...args) => {
  if (!isProduction()) {
  }
};

export const devWarn = (...args) => {
  if (!isProduction()) {
    console.warn('[DEV]', ...args);
  }
};

export const devError = (...args) => {
  // Always log errors, but with context
  console.error(`[${getEnvironment().toUpperCase()}]`, ...args);
};

export default config;
